<ui-input-wrapper
  [label]="base.label"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [randomInputId]="randomInputId"
  [labelTemplate]="base.labelTemplate"
  [errors]="control.errors"
  [submitted]="submitted()"
  [control]="control"
  [errorLabels]="base.errorLabels()">
  <form [formGroup]="innerFG" class="flex overflow-hidden w-full @max-[22rem]:flex-col @max-[22rem]:gap-2">
    <div class="flex items-end justify-center p-0 m-0 rounded-md flex-[1_1_0] min-w-0">
      <p-datepicker
        #calendarRefFrom
        [showIcon]="true"
        [inputId]="randomInputId"
        [placeholder]="placeholderFrom()"
        [appendTo]="dropdown.appendTo()"
        [showOnFocus]="false"
        (onShow)="setCorrectCalendarTopPosition()"
        (onClose)="handleOnClose()"
        (onMonthChange)="handleOnMonthChange()"
        (keydown)="restrictInput($event)"
        (keydown.enter)="handleOnEnter($event, datePicker.fromKey())"
        [showTime]="datePicker.showTime()"
        [showClear]="true"
        [timeOnly]="datePicker.timeOnly()"
        [baseZIndex]="10000"
        [firstDayOfWeek]="1"
        [panelStyle]="panelStyle()"
        [panelStyleClass]="dropdown.panelStyleClass()"
        [dateFormat]="datePicker.dateFormat()"
        [formControlName]="this.datePicker.fromKey()"
        [maxDate]="datePicker.minDate()"
        [keepInvalid]="datePicker.keepInvalid()"
        class="date-from min-w-0 flex w-full">
      </p-datepicker>
    </div>
    <div class="shrink-0 flex items-end p-0 m-0 rounded-md">
      <span class="self-center py-0 px-2.5 @max-[22rem]:hidden"> - </span>
    </div>
    <div class="flex items-end justify-center p-0 m-0 rounded-md flex-[1_1_0] min-w-0">
      <p-datepicker
        #calendarRefTo
        [showIcon]="true"
        [inputId]="randomInputId"
        [placeholder]="placeholderTo()"
        [appendTo]="dropdown.appendTo()"
        [showOnFocus]="false"
        (onShow)="setCorrectCalendarTopPosition()"
        (onClose)="handleOnClose()"
        (onMonthChange)="handleOnMonthChange()"
        (keydown)="restrictInput($event)"
        (keydown.enter)="handleOnEnter($event, datePicker.toKey())"
        [showTime]="datePicker.showTime()"
        [showClear]="true"
        [timeOnly]="datePicker.timeOnly()"
        [baseZIndex]="10000"
        [firstDayOfWeek]="1"
        [panelStyle]="panelStyle()"
        [panelStyleClass]="dropdown.panelStyleClass()"
        [dateFormat]="datePicker.dateFormat()"
        [formControlName]="this.datePicker.toKey()"
        [maxDate]="datePicker.maxDate()"
        [keepInvalid]="datePicker.keepInvalid()"
        class="date-to min-w-0 flex w-full">
      </p-datepicker>
    </div>
  </form>
</ui-input-wrapper>
